import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-glow"></div>
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo-link">
              <img src="/logo.png" alt="Tali Restaurants" className="footer-logo" />
            </Link>
            <div className="footer-social">
              <a
                href="https://www.linkedin.com/company/itstali"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link linkedin"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin"></i>
              </a>
              <a
                href="https://www.instagram.com/itstali_official"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link instagram"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </div>

          {/* Contact Section */}
          <div className="footer-contact">
            <h4 className="footer-heading">Contact</h4>
            <div className="contact-items">
              <div className="contact-item">
                <i className="bi bi-envelope-fill"></i>
                <span>hello@itstali.com</span>
              </div>
              <div className="contact-item">
                <i className="bi bi-telephone-fill"></i>
                <span>+20 102 008 650</span>
              </div>
              <div className="contact-item">
                <i className="bi bi-geo-alt-fill"></i>
                <span>Heliopolis, Cairo, Egypt</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <p className="copyright">
            &copy; {currentYear} Tali. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
